import { ExportCsvAction } from './actions/ExportCsvAction';
import { AddNoteAction } from './actions/AddNoteAction';
import { SetStatusAction } from './actions/SetStatusAction';
import { AssignCarrierAction } from './actions/AssignCarrierAction';
import { SendBolAction } from './actions/SendBolAction';
import { SendOrderListAction } from './actions/SendOrderListAction';
import { InvoiceAction } from './actions/InvoiceAction';
import type { BulkAction } from './types';

// Every bulk action the org orders toolbar offers, in display order. Adding a
// bulk action is one module here plus one line — the toolbar renders the rest.
export const BULK_ACTIONS: BulkAction[] = [
  ExportCsvAction,
  AddNoteAction,
  SetStatusAction,
  AssignCarrierAction,
  SendBolAction,
  SendOrderListAction,
  InvoiceAction,
];
